import logo from '../assets/images/logo.png'

export const logoData = {
    logo:logo
}